module.exports = __webpack_public_path__ + "img/icon3.b678e572.png";